var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSubTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.867,
    height: 168.692,
    viewBox: "0 0 174.867 168.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task-bro",
    transform: "translate(-305.688 -65.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-65",
    transform: "translate(312.331 65.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M76.057,32.909c37.824-7.347,63.724,22.6,73.167,33.014l28.438,31.371c8.61,9.5,17.459,19.428,20.311,31.094,3.539,14.476,1.5,39.459-10.58,50.288S158.342,195.95,140.9,198.7s-35.432,1.919-53.014-.092c-10.173-1.152-20.392-2.775-29.739-6.315s-17.835-9.19-22.468-16.806c-5.57-9.159-5.033-20.069-2.66-30.142s6.434-19.9,7.555-30.119C41.558,106.364,23.09,43.2,76.057,32.909Z",
    transform: "translate(-31.314 -31.762)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M76.057,32.909c37.824-7.347,63.724,22.6,73.167,33.014l28.438,31.371c8.61,9.5,17.459,19.428,20.311,31.094,3.539,14.476,1.5,39.459-10.58,50.288S158.342,195.95,140.9,198.7s-35.432,1.919-53.014-.092c-10.173-1.152-20.392-2.775-29.739-6.315s-17.835-9.19-22.468-16.806c-5.57-9.159-5.033-20.069-2.66-30.142s6.434-19.9,7.555-30.119C41.558,106.364,23.09,43.2,76.057,32.909Z",
    transform: "translate(-31.314 -31.762)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tasks--inject-65",
    transform: "translate(283.48 67.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262",
    transform: "translate(24.851 30.039)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8108",
    "data-name": "Path 8108",
    d: "M316.8,89.659a18.391,18.391,0,0,1-1.832,6.209c-1.063,2.349-1.2,4.643-2.713,6.867,7.1.364,12.46.9,15.146.545,2.993-4.2,3.119-10.251,2.461-14.95-4.2,1.273-9.328,0-13.691,1.063Z",
    transform: "translate(-312.25 -88.33)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8109",
    "data-name": "Path 8109",
    d: "M317.688,88a18.909,18.909,0,0,1-2.6,6,48.794,48.794,0,0,1-4.727,6.489,80.44,80.44,0,0,0,15.2.657,17.859,17.859,0,0,0,5.048-12.684C325.548,88.308,317.688,88,317.688,88Z",
    transform: "translate(-288.152 -58.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    transform: "translate(35.436 53.938)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M300.708,102.429a18.489,18.489,0,0,1-1.832,6.209c-1.063,2.335-.475,4.629-1.986,6.853,7.1.378,12.46.909,15.16.559,2.979-4.2,2.377-10.251,1.72-14.95-4.2,1.259-9.328,0-13.691,1.063Z",
    transform: "translate(-296.89 -101.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8111",
    "data-name": "Path 8111",
    d: "M301.808,100.76a19.1,19.1,0,0,1-2.6,6.013,48.8,48.8,0,0,1-4.727,6.489,81.684,81.684,0,0,0,15.2.657,17.914,17.914,0,0,0,5.1-12.684C309.668,101.1,301.808,100.76,301.808,100.76Z",
    transform: "translate(-262.415 -47.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(48.276 28.907)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8112",
    "data-name": "Path 8112",
    d: "M333.615,88.849a18.491,18.491,0,0,1-1.818,6.209c-1.063,2.335-1.287,4.629-2.8,6.853,7.118.378,12.474.909,15.16.559,2.993-4.2,3.2-10.251,2.559-14.95-4.2,1.259-9.342,0-13.705,1.063Z",
    transform: "translate(-329 -87.52)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8113",
    "data-name": "Path 8113",
    d: "M334.488,87.18a19.1,19.1,0,0,1-2.6,6.013,48.794,48.794,0,0,1-4.727,6.489,81.687,81.687,0,0,0,15.2.657,17.984,17.984,0,0,0,5.063-12.684C342.32,87.5,334.488,87.18,334.488,87.18Z",
    transform: "translate(-281.458 -58.749)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(135.037 147.036)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8114",
    "data-name": "Path 8114",
    d: "M395.669,173.319a18.488,18.488,0,0,1-1.832,6.209c-1.063,2.335-1.287,4.629-2.8,6.853,7.1.364,12.461.909,15.146.559,2.993-4.2,3.2-10.265,2.559-14.95-4.2,1.259-9.328,0-13.705,1.049Z",
    transform: "translate(-391.04 -171.99)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8115",
    "data-name": "Path 8115",
    d: "M396.538,171.65a19.1,19.1,0,0,1-2.6,6.013,47.779,47.779,0,0,1-4.727,6.475,82.159,82.159,0,0,0,15.216.671,18.026,18.026,0,0,0,5.048-12.67C404.4,171.972,396.538,171.65,396.538,171.65Z",
    transform: "translate(-256.732 -25.089)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266",
    transform: "translate(107.347 151.553)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8116",
    "data-name": "Path 8116",
    d: "M375.869,176.549a18.39,18.39,0,0,1-1.832,6.209c-1.077,2.349-1.3,4.643-2.8,6.867,7.1.364,12.461.9,15.16.545,2.979-4.2,3.2-10.251,2.545-14.95-4.2,1.259-9.328,0-13.705,1.063Z",
    transform: "translate(-371.24 -175.22)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8117",
    "data-name": "Path 8117",
    d: "M376.742,174.89a19.074,19.074,0,0,1-2.615,6,48.791,48.791,0,0,1-4.727,6.489,81.8,81.8,0,0,0,15.215.657,17.929,17.929,0,0,0,5.049-12.684C384.6,175.2,376.742,174.89,376.742,174.89Z",
    transform: "translate(-264.626 -23.798)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(82.496 147.26)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8118",
    "data-name": "Path 8118",
    d: "M358.1,173.479a18.307,18.307,0,0,1-1.832,6.209c-1.063,2.349-1.287,4.643-2.8,6.867,7.1.364,12.46.9,15.146.545,2.993-4.2,3.2-10.251,2.559-14.95-4.2,1.273-9.328,0-13.705,1.063Z",
    transform: "translate(-353.47 -172.15)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8119",
    "data-name": "Path 8119",
    d: "M358.968,171.82a19.1,19.1,0,0,1-2.6,6.013,49.591,49.591,0,0,1-4.727,6.475,82.161,82.161,0,0,0,15.215.671,18.04,18.04,0,0,0,5.049-12.7C366.842,172.072,358.968,171.82,358.968,171.82Z",
    transform: "translate(-271.703 -25.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1177",
    "data-name": "Rectangle 1177",
    width: 81.448,
    height: 119.738,
    transform: "translate(71.728 17.523)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8120",
    "data-name": "Path 8120",
    d: "M425.24,198.056H342.45l4.014-47.548a239.7,239.7,0,0,0,.811-24.753l-.937-47.464h81.028l.378,58.219c0,4.7,0,9.4-.28,14.083Z",
    transform: "translate(-275.365 -62.291)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8121",
    "data-name": "Path 8121",
    d: "M423.031,196.888H339.36l2.559-13.314c5.468-32.585,6.825-47.017,6.069-89.237l-.867-17.187h79.364l.937,16.236C429.436,164.038,423.031,196.888,423.031,196.888Z",
    transform: "translate(-276.596 -62.746)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M348.838,82.7a2.168,2.168,0,0,1,0-4.321.322.322,0,0,1,0,.643,1.524,1.524,0,1,0,1.524,1.524.322.322,0,1,1,.643,0,2.168,2.168,0,0,1-2.168,2.154Z",
    transform: "translate(-273.614 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8123",
    "data-name": "Path 8123",
    d: "M348.834,83.755c-1.986,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.112,4.629,2.126,5.16h-1.72a10.9,10.9,0,0,0-.419-2.937,10.457,10.457,0,0,0-.35,2.895h0a9.792,9.792,0,0,0,.364,2.909s0-.126,0-.21l.14-.462,1.189.35a.475.475,0,0,1,.322.587h0C350.19,83.1,349.617,83.755,348.834,83.755Z",
    transform: "translate(-273.651 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8124",
    "data-name": "Path 8124",
    d: "M350.208,80.869a.322.322,0,0,1-.322-.322,1.524,1.524,0,0,0-1.524-1.524.322.322,0,0,1-.322-.322.336.336,0,0,1,.322-.322,2.182,2.182,0,0,1,2.168,2.168.336.336,0,0,1-.322.322Z",
    transform: "translate(-273.137 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8125",
    "data-name": "Path 8125",
    d: "M356.118,82.7a2.168,2.168,0,0,1,0-4.321.322.322,0,0,1,0,.643,1.524,1.524,0,1,0,1.524,1.524.322.322,0,1,1,.643,0,2.168,2.168,0,0,1-2.168,2.154Z",
    transform: "translate(-270.713 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8126",
    "data-name": "Path 8126",
    d: "M356.114,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.07,4.6,2.07,5.132h-1.72a10.9,10.9,0,0,0-.42-2.937,10.46,10.46,0,0,0-.35,2.895h0a9.79,9.79,0,0,0,.364,2.909q.005-.1,0-.21l.14-.462,1.189.35a.475.475,0,0,1,.322.587h0C357.47,83.1,356.9,83.755,356.114,83.755Z",
    transform: "translate(-270.751 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M357.488,80.869a.322.322,0,0,1-.322-.322,1.524,1.524,0,0,0-1.524-1.524.322.322,0,0,1-.322-.322.336.336,0,0,1,.322-.322,2.182,2.182,0,0,1,2.168,2.168.336.336,0,0,1-.322.322Z",
    transform: "translate(-270.236 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M363.4,82.7a2.168,2.168,0,0,1,0-4.321.322.322,0,1,1,0,.643,1.524,1.524,0,1,0,1.524,1.524.322.322,0,0,1,.643,0A2.168,2.168,0,0,1,363.4,82.7Z",
    transform: "translate(-267.812 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M363.394,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.112,4.629,2.126,5.16H363.8a10.9,10.9,0,0,0-.419-2.937,10.457,10.457,0,0,0-.35,2.895h0a9.79,9.79,0,0,0,.364,2.909q.005-.1,0-.21l.14-.462,1.189.35a.475.475,0,0,1,.322.587h0C364.75,83.1,364.177,83.755,363.394,83.755Z",
    transform: "translate(-267.85 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8130",
    "data-name": "Path 8130",
    d: "M364.768,80.869a.322.322,0,0,1-.322-.322,1.524,1.524,0,0,0-1.524-1.524.322.322,0,0,1-.322-.322.336.336,0,0,1,.322-.322,2.182,2.182,0,0,1,2.168,2.168.336.336,0,0,1-.322.322Z",
    transform: "translate(-267.336 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8131",
    "data-name": "Path 8131",
    d: "M370.678,82.7a2.168,2.168,0,0,1,0-4.321.322.322,0,0,1,0,.643,1.524,1.524,0,1,0,1.524,1.524.322.322,0,0,1,.643,0,2.154,2.154,0,0,1-2.168,2.154Z",
    transform: "translate(-264.911 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8132",
    "data-name": "Path 8132",
    d: "M370.674,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.112,4.629,2.126,5.16h-1.72a10.9,10.9,0,0,0-.42-2.937,10.457,10.457,0,0,0-.35,2.895h0a9.79,9.79,0,0,0,.364,2.909q.005-.1,0-.21l.14-.462L372,81.2a.475.475,0,0,1,.322.587h0C372.03,83.1,371.457,83.755,370.674,83.755Z",
    transform: "translate(-264.949 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    d: "M372.048,80.869a.322.322,0,0,1-.322-.322,1.524,1.524,0,0,0-1.524-1.524.322.322,0,0,1-.322-.322.336.336,0,0,1,.322-.322,2.168,2.168,0,0,1,2.168,2.168.336.336,0,0,1-.322.322Z",
    transform: "translate(-264.435 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8134",
    "data-name": "Path 8134",
    d: "M378.017,82.7a2.168,2.168,0,1,1,0-4.321.322.322,0,1,1,0,.643,1.524,1.524,0,1,0,1.51,1.524.322.322,0,0,1,.643,0,2.154,2.154,0,0,1-2.154,2.154Z",
    transform: "translate(-262.125 -62.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8135",
    "data-name": "Path 8135",
    d: "M377.9,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.126,4.629,2.14,5.16h-1.72a10.265,10.265,0,0,0-.434-2.937,10.459,10.459,0,0,0-.35,2.895h0a10.223,10.223,0,0,0,.364,2.909,1.836,1.836,0,0,0,.07-.21l.126-.462,1.2.35a.476.476,0,0,1,.322.587h0C379.274,83.1,378.687,83.755,377.9,83.755Z",
    transform: "translate(-262.068 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8136",
    "data-name": "Path 8136",
    d: "M379.274,80.869a.336.336,0,0,1-.322-.322,1.51,1.51,0,0,0-1.51-1.524.322.322,0,1,1,0-.643,2.168,2.168,0,0,1,2.154,2.168A.322.322,0,0,1,379.274,80.869Z",
    transform: "translate(-261.55 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    "data-name": "Path 8137",
    d: "M385.3,82.7a2.168,2.168,0,1,1,0-4.321.322.322,0,1,1,0,.643,1.524,1.524,0,1,0,1.51,1.524.322.322,0,0,1,.643,0A2.154,2.154,0,0,1,385.3,82.7Z",
    transform: "translate(-259.224 -62.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8138",
    "data-name": "Path 8138",
    d: "M385.184,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.126,4.629,2.14,5.16H385.6a10.265,10.265,0,0,0-.434-2.937,10.457,10.457,0,0,0-.35,2.895h0a10.223,10.223,0,0,0,.364,2.909,1.836,1.836,0,0,0,.07-.21l.126-.462,1.2.35a.475.475,0,0,1,.322.587h0C386.554,83.1,385.967,83.755,385.184,83.755Z",
    transform: "translate(-259.167 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8139",
    "data-name": "Path 8139",
    d: "M386.554,80.869a.336.336,0,0,1-.322-.322,1.51,1.51,0,0,0-1.51-1.524.322.322,0,0,1,0-.643,2.168,2.168,0,0,1,2.154,2.168A.322.322,0,0,1,386.554,80.869Z",
    transform: "translate(-258.649 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8140",
    "data-name": "Path 8140",
    d: "M392.577,82.7a2.168,2.168,0,1,1,0-4.321.322.322,0,1,1,0,.643A1.524,1.524,0,1,0,394.1,80.55a.322.322,0,0,1,.643,0,2.154,2.154,0,0,1-2.168,2.154Z",
    transform: "translate(-256.323 -62.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8141",
    "data-name": "Path 8141",
    d: "M392.464,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.1-5.146,2.084-5.146s2.126,4.629,2.14,5.16h-1.72a10.265,10.265,0,0,0-.434-2.937,10.457,10.457,0,0,0-.35,2.895h0a10.221,10.221,0,0,0,.364,2.909,1.836,1.836,0,0,0,.07-.21l.126-.462,1.2.35a.475.475,0,0,1,.322.587h0C393.834,83.1,393.247,83.755,392.464,83.755Z",
    transform: "translate(-256.266 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8142",
    "data-name": "Path 8142",
    d: "M393.834,80.869a.336.336,0,0,1-.322-.322A1.51,1.51,0,0,0,392,79.023a.322.322,0,1,1,0-.643,2.168,2.168,0,0,1,2.154,2.168A.322.322,0,0,1,393.834,80.869Z",
    transform: "translate(-255.748 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8143",
    "data-name": "Path 8143",
    d: "M399.758,82.7a2.168,2.168,0,0,1,0-4.321.322.322,0,1,1,0,.643,1.524,1.524,0,1,0,1.51,1.524.322.322,0,0,1,.643,0,2.154,2.154,0,0,1-2.154,2.154Z",
    transform: "translate(-253.323 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8144",
    "data-name": "Path 8144",
    d: "M399.744,83.755c-1.972,0-2.084-4.2-2.084-5.118h0c0-.853.112-5.146,2.084-5.146s2.126,4.629,2.14,5.16h-1.72a10.263,10.263,0,0,0-.434-2.937,10.457,10.457,0,0,0-.35,2.895h0a10.223,10.223,0,0,0,.364,2.909,1.824,1.824,0,0,0,.07-.21l.126-.462,1.2.35a.475.475,0,0,1,.322.587h0C401.114,83.1,400.527,83.755,399.744,83.755Z",
    transform: "translate(-253.365 -64.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8145",
    "data-name": "Path 8145",
    d: "M401.114,80.869a.336.336,0,0,1-.322-.322,1.51,1.51,0,0,0-1.51-1.524.322.322,0,0,1,0-.643,2.168,2.168,0,0,1,2.154,2.168A.322.322,0,0,1,401.114,80.869Z",
    transform: "translate(-252.847 -62.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8146",
    "data-name": "Path 8146",
    d: "M362.79,78.36h12.4v-8.6A2.909,2.909,0,0,1,378.1,66.85h0a2.909,2.909,0,0,1,2.909,2.909v8.6h12.251",
    transform: "translate(-267.26 -66.85)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8147",
    "data-name": "Path 8147",
    d: "M370.335,85.56v1.93h-2.21V99.055H366V87.49h-2.21V85.56Z",
    transform: "translate(-266.861 -59.394)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M374.016,99.055l-.364-2.447h-2.6l-.378,2.447H368.73l2.168-13.5H374l2.1,13.5Zm-.713-4.279-1.021-6.825-1.021,6.825Z",
    transform: "translate(-264.893 -59.394)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M375.339,86.331a3.144,3.144,0,0,1,5.454,2.5v.434h-2v-.559a1.594,1.594,0,0,0-.266-1.021.993.993,0,0,0-.8-.308.965.965,0,0,0-.783.308,1.594,1.594,0,0,0-.28,1.021,2.461,2.461,0,0,0,.461,1.482,8.784,8.784,0,0,0,1.4,1.4,14.07,14.07,0,0,1,1.217,1.231,4.771,4.771,0,0,1,.783,1.273,4.2,4.2,0,0,1,.336,1.72,3.622,3.622,0,0,1-.811,2.517,3.049,3.049,0,0,1-2.349.881,3.007,3.007,0,0,1-2.349-.881,3.566,3.566,0,0,1-.811-2.517v-.783h2v.979c0,.867.364,1.3,1.1,1.3s1.091-.434,1.091-1.3a2.517,2.517,0,0,0-.448-1.482,9.44,9.44,0,0,0-1.4-1.4,16.486,16.486,0,0,1-1.217-1.217,5.285,5.285,0,0,1-.8-1.287,4.433,4.433,0,0,1-.322-1.72,3.622,3.622,0,0,1,.783-2.573Z",
    transform: "translate(-262.58 -59.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    "data-name": "Path 8150",
    d: "M382.016,94.9v4.2H379.89V85.56h2.126v5.874l2.8-5.874h2.112l-2.951,6.013,2.951,7.482h-2.182l-2.056-5.384Z",
    transform: "translate(-260.446 -59.394)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    "data-name": "Path 8151",
    d: "M364.59,100.834A132.731,132.731,0,0,1,397.622,97",
    transform: "translate(-266.543 -54.838)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 9.384,
    height: 9.384,
    transform: "translate(78.651 88.314)",
    fill: "none",
    stroke: "#64b5f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1179",
    "data-name": "Rectangle 1179",
    width: 9.384,
    height: 9.384,
    transform: "translate(77.364 103.655)",
    fill: "none",
    stroke: "#64b5f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1180",
    "data-name": "Rectangle 1180",
    width: 9.384,
    height: 9.384,
    transform: "translate(79.084 72.567)",
    fill: "none",
    stroke: "#64b5f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1181",
    "data-name": "Rectangle 1181",
    width: 9.384,
    height: 9.384,
    transform: "translate(80.021 57.729)",
    fill: "none",
    stroke: "#64b5f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    "data-name": "Path 8152",
    d: "M353.3,112.618h.769a11.621,11.621,0,0,0,1.986,5.706c.14.2.308.406.531.434s.587-.35.713-.685q2.629-6.5,4.741-13.2",
    transform: "translate(-271.041 -51.7)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M364.59,129.4c.965-1.916,1.986-3.8,2.951-5.734a17.912,17.912,0,0,1,2.8-4.6,7.72,7.72,0,0,1,1.091-.937.266.266,0,0,1,.252-.1c0,.42-.447.741-.629,1.1a.308.308,0,0,0,.364.112h1.748a2.657,2.657,0,0,1,1.594.462,1.4,1.4,0,0,1,.336,1.4,8.669,8.669,0,0,1-1.161,2.629,11.913,11.913,0,0,1-1.846,2.335,9.791,9.791,0,0,1-1.8,1.524c-.294.266-.573.322-.839.126s-.336-.266-.21-.587a3.245,3.245,0,0,1,.825-1.245,6.223,6.223,0,0,1,1.846-1.217,16.784,16.784,0,0,1,2.461-.937,5.6,5.6,0,0,1,1.4-.224h1.049a3.2,3.2,0,0,0,.713-.21,4.5,4.5,0,0,0-1.329,1.482l-.154.615.084.531.419.308a1.035,1.035,0,0,0,.979-.336,1.175,1.175,0,0,0,.517-.559,1.4,1.4,0,0,0,.308-.587.714.714,0,0,0,.084-.531.336.336,0,0,0-.154-.378.28.28,0,0,0-.322-.154.322.322,0,0,0-.336,0,1.4,1.4,0,0,0-.517.42,1.458,1.458,0,0,0,.475-.154c.42-.182.839-.322,1.273-.462a27.384,27.384,0,0,1,3.314-.839,1.9,1.9,0,0,1-.5.378,4.923,4.923,0,0,0-1.175.979,3.007,3.007,0,0,0-.517,1.5c0,.378,0,.909.559.909a1.944,1.944,0,0,0,1.063-.475,9.6,9.6,0,0,0,1.049-.951c.084-.084.755-.629.531-.867-.084.2-.154.392-.224.587a1.273,1.273,0,0,0,0,.685c.224.364.867-.084,1.091-.224a2.657,2.657,0,0,0,1.287-1.734,4.718,4.718,0,0,0-.266.965,1.58,1.58,0,0,0,0,1.049c.49,0,.769-.559,1.007-.937s.364-.755.657-.615a2.182,2.182,0,0,1-.168.783c0,.084-.084.322-.2.364a1.58,1.58,0,0,1,.475-.853.559.559,0,0,1,.49-.126,1.119,1.119,0,0,0,.811-.1c.308-.168.615-.35.909-.545s.252-.224.364-.112c-.168.517-.406,1.021-.531,1.538a3.392,3.392,0,0,1-.14.629.587.587,0,0,0,.126.671,2.49,2.49,0,0,0,.7-.2,14.438,14.438,0,0,0,2.21-1.035,4.7,4.7,0,0,0,1.4-1.119,1.468,1.468,0,0,0,.378-.545.531.531,0,0,0,.07-.587.993.993,0,0,0-.923.084l-.559.308a1.706,1.706,0,0,0-.825,1.315,1.161,1.161,0,0,0,.364,1.3.713.713,0,0,0,.993.28,3.8,3.8,0,0,0,1.4-.7,5.021,5.021,0,0,0,1.692-1.692c-.21,0-.7.937-.713.951-.21.378-.378.755-.573,1.133a2.993,2.993,0,0,1,.825-1.4c.378-.434.867-1.021,1.4-1.1a1.5,1.5,0,0,1-.168.811c-.07.182-.126.35-.182.531a1.006,1.006,0,0,0-.084.643.6.6,0,0,0,.853-.224,5.761,5.761,0,0,0,1.119-1.063,4.895,4.895,0,0,0,.853-1.217,1.259,1.259,0,0,0,.322-.9,4.824,4.824,0,0,0-.993,1.65,1.943,1.943,0,0,0-.238,1.007,1.4,1.4,0,0,0,.07.993,1.077,1.077,0,0,0,.671.951h.755l.811-.336a1.189,1.189,0,0,0,.629-.853,1.79,1.79,0,0,0,0-1.147.531.531,0,0,0-.448-.462l-.559-.168a5.943,5.943,0,0,0-1.217-.182s-.615,0-.713.112a7.23,7.23,0,0,0,2.391-.084,2.6,2.6,0,0,0,1.4-.573s-.238,0-.2.084.182,0,.238,0a.378.378,0,0,0-.07.322,7.314,7.314,0,0,0,1.482.643c.741.224,1.007.657.825,1.287a1.678,1.678,0,0,1-1.049,1.72c-.587.755-1.1.825-1.524.224a3.147,3.147,0,0,1,1.468-1.482,2.8,2.8,0,0,1,1.678-.7",
    transform: "translate(-266.543 -46.457)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M363.18,110.658c0,.713,3.93-.559,3.748-.517,3.258-.951,6.7-2.461,10.153-2.224",
    transform: "translate(-267.104 -50.496)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M368.59,107.589a.308.308,0,0,1,.322-.168,2.308,2.308,0,0,1-.154.5,22.239,22.239,0,0,0-.6,2.629c-.35,1.51-.741,2.993-1.147,4.461a6.082,6.082,0,0,0-.49,2.349",
    transform: "translate(-265.773 -50.685)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M369.849,110a10.952,10.952,0,0,1-.308,3.091,9.268,9.268,0,0,0-.6,2.335c1.077-1.4,1.636-3.286,3.44-3.916.392.6.084,1.4,0,2.07a5.341,5.341,0,0,0-.2,2.1,3.3,3.3,0,0,0,2.573-.629,6.573,6.573,0,0,0,2.307-1.888c.21-.364.476-1.4-.084-1.524s-1.063.643-1.3,1.063a3.86,3.86,0,0,0-.531,2.545,1.021,1.021,0,0,0,1.51.839c.741-.35,1.217-1.4,1.622-1.986a8.851,8.851,0,0,0,.629-1.063V114.2a10.628,10.628,0,0,1-.336,1.468c.419-1.077.517-3.4,1.972-3.608.308.308.154,1.189.154,1.524a4.725,4.725,0,0,0,0,1.091c.308,0,.685-.769.769-.909a5.063,5.063,0,0,1,.867-1.217c.657-.559,1.2-.252,1.4.573a3.972,3.972,0,0,1-.392,1.832,1.23,1.23,0,0,0-.07.671c.07.224.126.28.392.2.489-.154.9-.643,1.4-.825,1.329-.5,3.021-.951,3.79-2.266a.853.853,0,0,0-.266-1.273c-.671-.364-1.315.1-1.748.629a5.161,5.161,0,0,0-1.077,2.182,3.944,3.944,0,0,0-.07,2.377c.475.867,2.042-.308,2.321-.573a18.431,18.431,0,0,0,1.58-1.72",
    transform: "translate(-264.809 -49.656)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8157",
    "data-name": "Path 8157",
    d: "M389.136,110.079a.629.629,0,0,0-.154.685c.2,0,.322-.126.392-.364.461-.531.951-1.049,1.468-1.538.308-.308,1.72-1.958,2.321-1.608a10.125,10.125,0,0,1-.769,2.182,36.635,36.635,0,0,0-2,5.007L390,115.966a2.065,2.065,0,0,1-.07.643.462.462,0,0,0,.741,0",
    transform: "translate(-256.84 -50.769)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8158",
    "data-name": "Path 8158",
    d: "M362.47,139.995a2.1,2.1,0,0,1,.154-.5A11.187,11.187,0,0,1,365,136.415a49.03,49.03,0,0,1,5.272-4.615,16.013,16.013,0,0,1,3.119-2.14,2.993,2.993,0,0,1-.154,1.482c-.294,1.161-.755,2.266-1.049,3.426s-.448,1.916-.615,2.881c-.084.462-.35,1.4,0,1.86.461-.084.378-.783.392-1.049",
    transform: "translate(-267.387 -41.821)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M366.68,134.614a8.027,8.027,0,0,0,2.867-.434,27.663,27.663,0,0,0,3.986-1.3",
    transform: "translate(-265.71 -40.538)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M373.192,129.86h.126a46.47,46.47,0,0,1-1.4,4.433c-.35,1.091-.671,2.182-.951,3.3a1.916,1.916,0,0,0-.14,1.692.42.42,0,0,0,.49,0",
    transform: "translate(-264.11 -41.742)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8161",
    "data-name": "Path 8161",
    d: "M373.813,133.06a10.951,10.951,0,0,0-1.133,4.028c0,.238,0,.517.238.643s.49,0,.475-.21",
    transform: "translate(-263.319 -40.467)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8162",
    "data-name": "Path 8162",
    d: "M371.58,134.691a7.927,7.927,0,0,1,1.4.224h1.329a2.469,2.469,0,0,0,1.4-.266c.28,0,1.189.923,1.482.909a1.4,1.4,0,0,0,1.077-.8c.238-.434.07-.657-.475-.727a1.4,1.4,0,0,0-1.4.545c-.5.7-.867,3.007.741,2.671a3.664,3.664,0,0,0,2.028-1.58,16.894,16.894,0,0,0,1.58-2.07c-.8.657-.378,1.86-.783,2.643-.084-1.077,1.063-2.713,2.461-2.321.322.084.2.224,0,.5-.308.671-.741,1.273-1.021,1.958.5-.657.853-1.4,1.4-2.084.14-.182.49-.7.853-.643.853.1.42,1.762.517,2.252.448.126,1.259-.7,1.4-.839a12.461,12.461,0,0,1,1.972-1.65c-.168.9-1.4,1.482-1.175,2.517.517-.112.8-.783.993-1.161s.238-.9.517-1.077c.182.21-.168.811-.112,1.091a1.636,1.636,0,0,0,.993,1.133c1.65.657,3.342-1.566,3.944-2.6a4.993,4.993,0,0,0-.9,1.566l-.392,1.133a.867.867,0,0,0,.112,1.259h.741a2.923,2.923,0,0,0,1.273-1.077,3.006,3.006,0,0,0,.7-1.035,2.154,2.154,0,0,0,.392-1.4",
    transform: "translate(-263.757 -40.363)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8163",
    "data-name": "Path 8163",
    d: "M387.961,132.247h-.126a.336.336,0,0,0,0,.308c.252-.1.392-.629,0-.573-.168.322.084.35.406.364",
    transform: "translate(-257.301 -40.898)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8164",
    "data-name": "Path 8164",
    d: "M384.7,134.624h2.084a12.974,12.974,0,0,0,1.65,0c.308,0,1.147-.587,1.4-.6v-.084c.252.2.14.853.168,1.1s0,1.594.489,1.622a13.981,13.981,0,0,0,1.133-1.72l.839-1.133a1.287,1.287,0,0,1,.573-.643,2.292,2.292,0,0,1-.294.853,2.014,2.014,0,0,0,.587,1.594c.713.28,1.4-.336,1.734-.783.2-.224.615-.881.294-1.189s-1.636.154-2.028.42c-.643.448-2.168,2.335-.727,2.8a2.391,2.391,0,0,0,2.21-.545,6.071,6.071,0,0,0,1.175-1.063.713.713,0,0,1,.531-.448",
    transform: "translate(-258.529 -40.423)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8165",
    "data-name": "Path 8165",
    d: "M367.232,141.378c.322-.14.21.266.168.406-.406,1.217-.993,2.377-1.4,3.594a10.488,10.488,0,0,0-.867,3.706.769.769,0,0,0,.392.825.35.35,0,0,0,.461-.084",
    transform: "translate(-266.331 -37.163)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M365,141.505v.1a1.889,1.889,0,0,0,.559,0,13.023,13.023,0,0,0,2.433-.308c.8-.168,1.58-.378,2.391-.517a1.2,1.2,0,0,1,.769,0,.392.392,0,0,1,.476.378",
    transform: "translate(-266.379 -37.416)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M364.59,145.052a18.18,18.18,0,0,1,5.818-1.482",
    transform: "translate(-266.543 -36.279)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M370.032,144.39a5.593,5.593,0,0,1-.322,1.273,6.661,6.661,0,0,0-.14,1.58",
    transform: "translate(-264.559 -35.952)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M370.63,143.272v-.112",
    transform: "translate(-264.136 -36.442)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M371.224,144.558c.406-.1.21.7.2.811-.14.755-.475,1.4-.559,2.224a.686.686,0,0,0,.168-.35c.21-.475.433-.951.657-1.4a5.06,5.06,0,0,1,1.175-1.538.657.657,0,0,1,.643-.336,11.924,11.924,0,0,1-.447,2.6c-.07.448-.364,1.329.112,1.664",
    transform: "translate(-264.044 -36.12)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M374.4,144.31a16.559,16.559,0,0,0-.923,3.664c.252.084.531-.6.587-.7",
    transform: "translate(-263 -35.984)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8172",
    "data-name": "Path 8172",
    d: "M374.88,143.112V143",
    transform: "translate(-262.442 -36.506)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8173",
    "data-name": "Path 8173",
    d: "M377.423,144a9.535,9.535,0,0,0-1.482,1.007l-.573.517-.308.448c0,.378.587.322.825.364a1.175,1.175,0,0,1,.881.35c.252.392,0,.811-.28,1.133s-1.4,1.4-1.4.517",
    transform: "translate(-262.37 -36.107)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M378.556,143.49c-.308.783-.643,1.552-.923,2.349-.084.238-.713,1.678-.489,1.818.35-.406.643-.853,1.007-1.245s.769-1.021,1.2-.867a9.562,9.562,0,0,0,.476,1.3,1.269,1.269,0,0,0,1.4.755,3.454,3.454,0,0,0,1.8-2.21,2.8,2.8,0,0,0-.545,1.049,6.348,6.348,0,0,0-.573,2.07",
    transform: "translate(-261.559 -36.31)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M381.634,142.84a.294.294,0,0,1-.224.112",
    transform: "translate(-259.84 -36.569)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8176",
    "data-name": "Path 8176",
    d: "M382.152,147.1c-.112.462-.224.923-.322,1.4.489-1.4.923-3.077,2.433-3.678.671-.266.741.238.755.811a6.354,6.354,0,0,1,0,1.035.5.5,0,0,0,0,.657l.391-.21",
    transform: "translate(-259.673 -35.809)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8177",
    "data-name": "Path 8177",
    d: "M386.111,144.4c-.266.308-1.776,2.321-.741,2.294.49,0,.979-.881,1.147-1.189a2.95,2.95,0,0,1,.713-1.147c.308.154.28.587.336.881a9.495,9.495,0,0,1,0,2.951,3.048,3.048,0,0,1-.615,1.524,2.154,2.154,0,0,1-1.552.867.783.783,0,0,1-.615-.559,1.609,1.609,0,0,1,.559-1.4l1.287-1.021c.741-.489,1.482-1.007,2.21-1.524l2.252-1.622",
    transform: "translate(-258.5 -35.964)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubTasks);
export default __webpack_public_path__ + "static/media/noSubTasks.a7c9afd500a8f1b6afdf56d84654b73f.svg";
export { ForwardRef as ReactComponent };